import React from "react";
import GoogleLogin from "react-google-login";
import ContinueWithGoogleButton from "../components/ContinueWithGoogle";
import LoginApi from "../apis";
import { useDispatch } from "react-redux";
import { logIn } from "../actionCreator";
import { getUserInfo } from "../utils";
import PropTypes from "prop-types";
const propTypes = {
  /** Called when Google login is requested */
  onRequest: PropTypes.func,
  /** Called when Google login is complete (both failure and success) */
  onCompletion: PropTypes.func,
  /** Function to display feedback to user (like showing toast) */
  showToast: PropTypes.func,
};

/**
 * This is used to login with google where display of toast, and
 * handling loading state is left to the parent
 */
const ContinueWithGoogle = ({
  onRequest,
  onCompletion,
  showToast,
  platForm,
} = {}) => {
  const dispatch = useDispatch();
  function onFailure() {
    showToast("Login Failed");
    onCompletion && onCompletion();
  }
  function onSuccess(response) {
    if (!response || !response.profileObj || !response.profileObj.email) {
      onFailure();
      return;
    }
    const requestData = {
      AccessToken: response.tokenId,
      Email: response.profileObj.email,
      SocialPlatform: "g",
      FbId: 0,
      platForm: platForm,
    };
    LoginApi.socialMediaSignIn(requestData)
      .then(apiResponse => {
        if (apiResponse && apiResponse.status === 400 && apiResponse.message) {
          showToast(apiResponse.message);
        } else {
          showToast("Logged in successfully");
          dispatch(logIn(getUserInfo(apiResponse)));
        }
      })
      .catch(onFailure);
    onCompletion && onCompletion();
  }
  return (
    <GoogleLogin
      clientId={GOOGLE_LOGIN_CLIENT_ID}
      render={ContinueWithGoogleButton}
      buttonText="Google"
      onRequest={onRequest}
      onSuccess={onSuccess}
      onFailure={onFailure}
    />
  );
};
ContinueWithGoogle.propTypes = propTypes;
export default ContinueWithGoogle;
